import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import * as layoutActions from 'Global/Stores/layout'
import * as previewModalActions from 'Global/Stores/previewModal'
import * as rugsAsyncActions from 'Global/Stores/rugs'
import * as selectors from './selectors'

const module = 'myOrders'

const layoutToggle = layoutActions.makeLayoutToggle(module)
const limitToggle = layoutActions.makeLimitToggle(module)
const pageSet = layoutActions.makePageSet(module)
const previewModalToggle = previewModalActions.makePreviewModalToggle(module)
const sortBySet = layoutActions.makeSortBySet(module)
const sortOrderToggle = layoutActions.makeSortOrderToggle(module)

const MyOrdersModuleHOC = WrappedComponent => {
  class MyOrdersModuleHOC extends Component {
    static propTypes = {
      allRugs: PropTypes.array.isRequired,
      exportToExcel: PropTypes.func.isRequired,
      filteredRugs: PropTypes.array.isRequired,
      getRugs: PropTypes.func.isRequired,
      layout: PropTypes.string.isRequired,
      previewOpen: PropTypes.bool.isRequired,
      rugsDone: PropTypes.bool.isRequired,
      rugsError: PropTypes.bool.isRequired,
      rugsPending: PropTypes.bool.isRequired,
      setPage: PropTypes.func.isRequired,
      setSortBy: PropTypes.func.isRequired,
      toggleLayout: PropTypes.func.isRequired,
      toggleLimit: PropTypes.func.isRequired,
      togglePreview: PropTypes.func.isRequired,
      toggleSortOrder: PropTypes.func.isRequired,
      user: PropTypes.object.isRequired,
    }

    componentDidMount() {
      const { getRugs, rugsDone } = this.props

      if (!rugsDone) {
        getRugs()
      }
    }

    exportToExcel = e => {
      const { allRugs, exportToExcel } = this.props

      e.preventDefault()
      exportToExcel(allRugs)
    }

    setPage = page => {
      const { setPage } = this.props

      setPage(page)
      window.scrollTo(0, 0)
    }

    render() {
      const { rugsError, filteredRugs, rugsPending } = this.props

      return (
        <WrappedComponent
          exportToExcel={this.exportToExcel}
          hasError={rugsError}
          loaderPending={rugsPending && !rugsError}
          rugs={filteredRugs}
          setPage={this.setPage}
          {...this.props}
        />
      )
    }
  }

  const mapStateToProps = (state, ownProps) => ({
    allRugs: selectors.filterRugs(state),
    filteredRugs: selectors.slicedFilteredRugs(state),
    layout: selectors.layout(state),
    limit: selectors.limit(state),
    pagination: selectors.calculatePagination(state),
    previewOpen: selectors.previewOpen(state),
    rugsDone: selectors.rugsDone(state),
    rugsError: selectors.rugsError(state),
    rugsPending: selectors.rugsPending(state),
    sortBy: selectors.sortBy(state),
    sortOrder: selectors.sortOrder(state),
    user: selectors.user(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    exportToExcel: rugs => dispatch(rugsAsyncActions.rugsExportExcel(rugs)),
    getRugs: () => dispatch(rugsAsyncActions.rugsGet()),
    setPage: page => dispatch(pageSet(page)),
    setSortBy: column => dispatch(sortBySet(column)),
    toggleLayout: () => dispatch(layoutToggle()),
    toggleLimit: () => dispatch(limitToggle()),
    togglePreview: () => dispatch(previewModalToggle()),
    toggleSortOrder: order => dispatch(sortOrderToggle()),
  })

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(MyOrdersModuleHOC)
}

export default MyOrdersModuleHOC
